export default {
    statusActions: {
        validate: 'Validiraj',
        approve: 'Odobri',
        revertToDraft: 'Vrati u nacrt',
        lock: 'Zaključaj',
        unlock: 'Otključaj',
        statusChangedTitle: 'Status → {target}',
        transitionRejectedTitle: 'Prijelaz odbijen',
        transitionRejectedMessage: 'prijelaz odbijen',
        transitionFailedMessage: 'prijelaz nije uspio',
    },
}
